<template>
    <div class="game">

        <!-- 移动端横屏提醒 -->
        <div class="Landscapescreen" v-if="Landscapescreen">
            <div style="width:50%;text-align: center;margin: auto;">
                <div class="mobiletip">
                    <img src="../../assets/game/mobiletip.png" >
                </div>
                <p style="color: #fff;">请打开手机屏幕自动旋转,横屏查看下面的内容</p>
            </div>
        </div>

        <!-- 蒙版 -->
        <div class="Mask" v-if="Mask">
            <div class="countdown">
                <p class="title">倒计时</p>
                <p class="tip">测试即将开始，请准备</p>
                <span class="time">{{ time }}</span>
                
            </div>
        </div>
        <!-- 内容 -->
        <div class="content">
        <i class="bg" @click="clickaction"></i>
            <info ref="infochild" :errorNum="resultparams.faultQty" :score="resultparams.rightRate" :rankDetail="rankDetail"></info>
            <el-button @click="requestFullscreen()" style="position: absolute;z-index: 99;top: 0;left:0;" v-if="buttonstatu">全屏{{ buttonstatu }}</el-button>
            <div class="cognitivetraining">
                <div style="display:flex;align-items: center;">
                    <span class="remainder" :style="{color:Total<=10?'red':'#02C9C9'}">{{remainder}}</span>
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="percentage" color="#02C9C9" style="width:80%;display: inline-block;font-size: 1em;"></el-progress>
                </div>
                <ul>
                    <li v-for="(item,index) in randomNum" @click="ChooseNum(item,index)" :style="{flex:100/maxnumber<15?'15%':100/maxnumber+'%',height:100/maxnumber+'%'}"><span :style="{background:item.background}">{{item.name}}</span></li>
                </ul>
            </div>
            <rank ref="child"></rank>
        </div>

        <!-- 结束后遮罩 -->
        <div class="overmask" v-if="overmask">
            <i class="el-icon-close" style="color: #fff;position: absolute;right: 10vw;top: 10vh;font-size: 2em;" @click="overmask=false"></i>
            <div class="success">
                <img :src="result.zHeadPhotoURL" style="width: 10vw;border-radius: 50%;overflow: hidden;">
                <p class="statu">{{result.text}}</p>
                <p>恭喜你超过了{{result.currentRank==1?'99':((result.total-result.currentRank)/result.total)*100}}%的玩家，排名第{{result.currentRank}}名，继续加油</p>
                <el-button style="background: none;border-color: #02c9c9;color:#02c9c9;margin-top: 1em;" round @click="$router.go(-1)">来，继续下一个游戏吧</el-button>
            </div>
        </div>

    </div>
</template>
<script>
import info from './components/info.vue'
import rank from './components/rank.vue'
export default{
    name:'cognitivetraining',
    data() {
        return {
            Mask:true,
            randomNum:[],
            percentage:0,
            clearsetInter:'',
            time:3,
            Total:0,
            remainder:'00:00',
            overmask:false,
            Correctquantity:[],
            rankDetail:'',
            result:'',
            screenWidth: document.body.clientWidth, // 网页可见区域宽
            screenHW: window.orientation,// 判断横竖屏
            Landscapescreen:true,
            maxnumber:0,
            buttonstatu:true,
            resultparams:{
                trainKey:this.$route.query.trainKey,
                diffType:this.$route.query.diffType,
                faultQty:0,
                rightRate:0,
                detailList:[]
            }
        }
    },
    watch:{
        Correctquantity(newval,oldeval){
            let TotalNum=this.randomNum.length;
            let correctNum=this.Correctquantity.length;
            if(correctNum+this.resultparams.faultQty<this.maxnumber*this.maxnumber){
                this.resultparams.rightRate=Math.floor((correctNum/TotalNum)*100);
            }else{
                this.resultparams.rightRate=Math.floor(((TotalNum-this.resultparams.faultQty)/TotalNum)*100);
            }
        },
        screenWidth(val) {
            // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
            if (!this.timer) {// 一旦监听到的screenWidth值改变，就将其重新赋给data里的
                this.screenWidth=this.screenWidth = val;
                this.timer = true;
                let that = this;
                setTimeout(function() {// 执行自适应代码
                    that.timer = false;
                }, 400);
            }
        },
        screenHW() {
            this.rotate()
        }
    },
    created() {
        this.maxnumber=this.$route.query.value;
        this.Total=this.$route.query.Time
        let a=this.generateUniqueRandomNumbers(1, this.maxnumber*this.maxnumber);
        if(this.screenWidth>750){
            this.Landscapescreen=false
            this.countdown();
        }else{
            this.rotate();
        }
    },
    
    mounted(){// 监听窗口大小
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;// 把横竖屏的变化赋值
                this.screenHW = window.orientation;
            })()
        }
    },
    methods: {
        // 进入全屏
        requestFullscreen(){
            this.buttonstatu=false;
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) { // Firefox
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
                document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
                document.documentElement.msRequestFullscreen();
            }
        },

        // 退出全屏 
        exitFullscreen(){
            this.buttonstatu=true;
            this.$router.go(-1);
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
            }
        },

        rotate () {
            this.Total=0;
            if (this.screenHW == 180 || this.screenHW == 0) {//竖屏
                this.Landscapescreen=true;
                clearInterval(this.clearsetInter);
                this.percentage=0;
                this.resultparams.rightRate=0;
                this.resultparams.faultQty=0;
                this.Correctquantity=[];
                this.Total=this.$route.query.Time;
                clearInterval(this.clearsetInter);
                this.generateUniqueRandomNumbers(1, this.maxnumber*this.maxnumber);
            } else if (this.screenHW == 90 || this.screenHW == -90) {//横屏
                this.Landscapescreen=false;
                this.Mask=true;
                // this.countdown();
            }
        },
        // 生成随机数
        generateUniqueRandomNumbers(min, max) {
            this.randomNum=[];
            const numbers = Array.from({ length: max - min + 1 }, (_, index) => min + index);
            for (let i = numbers.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
            }
            for(let item of numbers){
                let str={name:item,choose:'',background:'#E5F9F9'}
                this.randomNum.push(str)
            }
            return numbers;
        },

        //训练开始倒计时
        countdown(){
            this.Total=this.$route.query.Time
            let _this=this;
            this.clearsetInter=setInterval(function(){
                if(_this.time<=1){
                    clearInterval(_this.clearsetInter);
                    _this.Totalcountdown();
                    _this.Mask=false;
                }else{
                    _this.time--;
                }
            },1000);
        },
        // 计算剩余时间
        Calculateremaining(){
            let minute=parseInt(this.Total/60)<10?'0'+parseInt(this.Total/60):parseInt(this.Total/60)
            let second=parseInt(this.Total%60)<10?'0'+parseInt(this.Total%60):parseInt(this.Total%60);
            this.remainder=`${minute}:${second}`;
            
        },

        // 答题倒计时
        Totalcountdown(){
            let _this=this;
            _this.resultparams['startTime']=new Date().getTime();
            this.clearsetInter=setInterval(() => {
                if(_this.Total<=1){
                    _this.remainder="00:00"
                    clearInterval(_this.clearsetInter);
                    if(this.Correctquantity.length==0){
                        this.$message({type: 'error', message:"由于您本次未作答，本次测评不做提交"})
                    }else{
                        clearInterval(_this.clearsetInter);
                        _this.resultparams['endTime']= new Date().getTime();
                        _this.OpenAnswer();
                    }
                }else{
                    if(_this.resultparams.rightRate==100 || _this.Correctquantity.length==_this.randomNum.length){
                        clearInterval(_this.clearsetInter);
                        _this.resultparams['endTime']= new Date().getTime();
                        _this.OpenAnswer();
                        return;
                    }else{
                        _this.Total--;
                        _this.Calculateremaining();
                    }
                }
            }, 1000);
        },



        // 选择
        ChooseNum(val,index){
            if(this.Total<=1){return false;}
            let str={lineNumber:val.name,RIndex:'',rageTime:'',currenttime:new Date().getTime()};
            if(this.Correctquantity.length+1==val.name){
                this.Correctquantity.push(val.name);
                str['RIndex']=1;
                this.resultparams.detailList.push(str);
                this.percentage=Math.floor((this.Correctquantity.length/this.randomNum.length)*100);
                this.randomNum[index].choose=val.name;
                this.randomNum[index].background='green';
            }else{
                if(val.name==val.choose){//已选择
                    return false;
                }else{//错误选项
                    str['RIndex']=2;
                    this.resultparams.detailList.push(str);
                    this.resultparams.faultQty=val.choose==''?this.resultparams.faultQty+=1:this.resultparams.faultQty;
                    this.randomNum[index].choose=999;
                    this.randomNum[index].background='rgb(223, 223, 223)';
                }
            }
            this.setmap();
        },

        // 去重
        setmap(){
            let map = new Map();
            for (let item of this.resultparams.detailList) {
                if (!map.has(item.lineNumber)) {
                    map.set(item.lineNumber, item);
                };
            };
            this.resultparams.detailList= [...map.values()];
            
        },
        
        // 重置
        RestartGame(){
            this.percentage=0;
            this.resultparams.rightRate=0;
            this.resultparams.faultQty=0;
            this.Correctquantity=[];
            this.Total=this.$route.query.Time;
            clearInterval(this.clearsetInter);
            this.generateUniqueRandomNumbers(1, this.maxnumber*this.maxnumber, this.maxnumber*this.maxnumber);
            this.Totalcountdown();
        },
        // 点击打开排行榜
        clickaction(){
            this.$refs.child.actionicon();
            this.$refs.infochild.detailinfo();
        },
        // 打开提交答案弹窗
        OpenAnswer(){
            this.$confirm('是否确认提交答案?', {
                closeOnPressEscape:false,
                closeOnClickModal:false,
                showClose:false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.resultparams['rightQty']=this.Correctquantity.length;//正确数量
                this.resultparams['faultRate']=100-this.resultparams.rightRate;//错误率
                this.resultparams['averageTime']=Math.floor((this.resultparams.endTime-this.resultparams.startTime)/1000/this.Correctquantity.length);
                this.resultparams['totalTime']=Math.floor((this.resultparams.endTime-this.resultparams.startTime)/1000);
                let list=this.resultparams.detailList;
                for(var i=0;i<list.length;i++){
                    if(i==0){
                        list[i]['rageTime']=list[i]['currenttime']-this.resultparams.startTime;
                    }else{
                        list[i]['rageTime']=list[i]['currenttime']-list[i-1]['currenttime'];
                    }
                }
                this.resultparams['startTime']=this.Global.formatDate(new Date(this.resultparams['startTime']),'YYYY-MM-DD HH:mm:ss');
                this.resultparams['endTime']=this.Global.formatDate(new Date(this.resultparams['endTime']),'YYYY-MM-DD HH:mm:ss');
                this.$Http_Post('app/game/submitresult',this.resultparams).then(res=>{
                    if(res.Code==0){
                        this.result=res.Data;
                        if(this.resultparams.rightRate<60){
                            this.result['text']='再接再厉'
                        }else if(this.resultparams.rightRate>=60 && this.resultparams.rightRate<=80){
                            this.result['text']='合格'
                        }else{
                            this.result['text']='优秀'
                        }
                        this.overmask=true;
                    }else{
                        this.$message({type: 'error', message: res.Message})
                    }
                });
            }).catch((action) => {
                this.$message({type: 'error', message:"取消提交"})      
            });
        },
        // 接收排行榜数据
        getrankDetail(val){
            this.rankDetail=val;
        }
    },
    beforeDestroy() {
        clearInterval(this.clearsetInter);
    },
    components:{
        info,
        rank
    }
}
</script>
<style scoped>
.game{position: absolute;top:0;left:0;width: 100%;height:100vh;overflow: hidden;background:url('../../assets/game/mobilegame_bg.png') repeat scroll;background-size: 100%;}
.game .bg{position: absolute;top: 0;left:0;width: 100%;height:100%;}
.content{height:100%;display: flex;justify-content:space-between;position: relative;z-index: 2;}
.game .bg{position: absolute;top:0;left:0;width: 100%;height:100vh;}
.cognitivetraining{position: absolute;top:50%;left:50%;width:32vw;height:32vw;z-index:2;transform: translate(-50%,-50%);}
.cognitivetraining ul{display: flex;flex-wrap: wrap;justify-content: flex-start;width: 100%;height:100%;font-size: 1.5em;overflow: auto;}
.cognitivetraining ul li{text-align: center;font-weight: bold;min-height: 15%;}
.cognitivetraining ul li span{background: #E5F9F9;margin:3% 3% 0 0;width:95%;height:95%;display: flex;align-items: center;justify-content: center;}
.cognitivetraining ul li.on span{background:#02C9C9;}
.Mask{background: rgb(255 255 255 / 94%);position: absolute;top:0;left:0;width:100%;height:100%;z-index:9;display: flex; justify-content: center;align-items: center;}
.Mask .countdown{color: #02C9C9;text-align: center;}
.Mask .countdown .title{font-size: 2em;}
.Mask .countdown .tip{padding: .5em 0;}
.Mask .countdown .time{width: 4em;height: 4em;border-radius: 50%;border: .1em solid #02C9C9;display: inline-block;text-align: center;line-height: 4em;font-size: 1.5em;}
.remainder{font-size:1.5em;font-weight: bold;margin-right: .5em;}

.overmask{position: fixed;top:0;left:0;width:100%;height:100%;background: rgb(0 0 0 / 90%);z-index: 99;display: flex;align-items: center; justify-content: center;}
.overmask .success{color: #fff;text-align: center;}
.overmask .success .statu{font-size: 1.5em;color:#02C9C9;padding:.5em;}


/* 横屏提醒 */
.Landscapescreen{position: fixed;top:0;left:0;width:100%;height: 100%;z-index: 999;background: rgb(0 0 0 / 80%);display: flex;}
.Landscapescreen .mobiletip{width: 40%;margin: auto;}
.Landscapescreen .mobiletip img{width:100%;display: block;}

@media screen and (orientation:landscape) {

/* .game{background-color: #000;} */

}
</style>